import React from "react";
import { PerceptualCrossing } from "../examples/PerceptualCrossing";

export function MainTask() {
  return (
    <div className="h-full flex flex-col">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold mb-4">Perceptual Crossing Task</h2>
        <p className="text-lg">
          Find and maintain contact with the other participant. The circle will light up when you're
          near an object or the other participant.
        </p>
      </div>
      <div className="flex-grow">
        <PerceptualCrossing 
          tutorial={false} 
          stageType="main"
          // hideVisuals={true} // comment this line to show visuals for testing

        />
      </div>
    </div>
  );
} 